import { useQuery } from "@tanstack/react-query";
import { getBundle } from "../services/get-bundle";

export function useBundle(id: string | undefined) {
  return useQuery({
    queryKey: ["bundle", id],
    queryFn: () => getBundle(id!),
    enabled: !!id,
  });
}
